
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Box, Dialog, IconButton, Stack, Typography } from "@mui/material";
import { useEffect, useRef, type ReactNode } from "react";
import { APP_UI } from "../ui/appUi";
import { useSheetDismiss } from "../hooks/useSheetDismiss";
export default function AppFullscreenDialog({open,onClose,title,subtitle,children,zIndex=1800}:{open:boolean;onClose:()=>void;title:string;subtitle?:string;children:ReactNode;zIndex?:number}){
 const {requestClose}=useSheetDismiss(open,onClose);
 const contentRef=useRef<HTMLDivElement|null>(null);
 useEffect(()=>{
  if(!open)return;
  const frame=window.requestAnimationFrame(()=>{
   const root=contentRef.current;
   if(!root)return;
   root.scrollTop=0;
   root.querySelectorAll<HTMLElement>("*").forEach((element)=>{if(element.scrollTop>0)element.scrollTop=0;});
  });
  return()=>window.cancelAnimationFrame(frame);
 },[open]);
 return <Dialog open={open} onClose={requestClose} disableRestoreFocus fullScreen sx={{zIndex}} slotProps={{paper:{sx:{bgcolor:APP_UI.background,color:APP_UI.text,backgroundImage:"none"}}}}>
  <Stack direction="row" spacing={1} sx={{pl:"max(11px, env(safe-area-inset-left, 0px))",pr:"max(11px, env(safe-area-inset-right, 0px))",pt:"calc(env(safe-area-inset-top, 0px) + 8px)",pb:1,alignItems:"center",borderBottom:`1px solid ${APP_UI.border}`,minHeight:"calc(60px + env(safe-area-inset-top, 0px))"}}><Box sx={{flex:1,minWidth:0}}><Typography variant="h6" sx={{fontWeight:900}}>{title}</Typography>{subtitle&&<Typography variant="caption" sx={{color:APP_UI.textMuted}}>{subtitle}</Typography>}</Box><IconButton onClick={requestClose} aria-label="Schließen" sx={{color:"#fff",width:APP_UI.touch,height:APP_UI.touch}}><CloseRoundedIcon/></IconButton></Stack>
  <Box ref={contentRef} sx={{flex:1,minHeight:0,overflow:"hidden"}}>{children}</Box>
 </Dialog>;
}
